import { log } from '../utils/loggingUtil';
import { PREBID_IFRAME_ORIGIN } from '../rui-env-variables';

const prebidResultListener = (message, handler) => (event) => {
  if (event.origin !== PREBID_IFRAME_ORIGIN) return;

  let data;
  try {
    data = JSON.parse(event.data);
  } catch (e) {
    return;
  }

  if (data.message && data.message === message) {
    event.stopImmediatePropagation();

    handler(data);
  }
};

let eventListeners = [];
const removePrebidEventListeners = () => {
  eventListeners.forEach((eventListener) =>
    window.removeEventListener('message', eventListener),
  );
  eventListeners = [];
};

const postMsgToRemoveAdUnits = () => {
  if (typeof window.frames.prebid?.postMessage !== 'function') {
    return;
  }
  const message = JSON.stringify({
    message: 'remove_ad_units',
  });
  window.frames.prebid.postMessage(message, PREBID_IFRAME_ORIGIN);
};

const clearPrebidState = () => {
  removePrebidEventListeners();
  postMsgToRemoveAdUnits();
};

const waitForPrebidIfRequired = (adSpot) => {
  if (!adSpot.isPrebid) {
    return Promise.resolve({ bidResult: undefined, isDemoApp: false });
  }
  const prebidMessage = `bidding_completed_${adSpot.params.pos}`;

  return new Promise((resolve) => {
    const prebidResultReceiver = prebidResultListener(
      prebidMessage,
      ({ bidResult, isDemoApp }) => {
        log(
          `Prebid result received for ${adSpot.params.pos} event listener. bidResult: `,
          bidResult,
        );

        window.removeEventListener('message', prebidResultReceiver);
        eventListeners = eventListeners.filter(
          (eventListener) => eventListener !== prebidResultReceiver,
        );

        resolve({ bidResult, isDemoApp });
      },
    );

    window.addEventListener('message', prebidResultReceiver, false);
    eventListeners.push(prebidResultReceiver);
  });
};

export { waitForPrebidIfRequired, clearPrebidState };
